import initialState from '../store/initialState'
import questionsTypes from '../constants/questionsTypes'

export default function progressReducer(state = initialState.progress, action) {
  switch (action.type) {
    case "UPDATE_PROGRESS_BAR": {
      return {
        progress: action.payload
      }
    }

    case questionsTypes.upload_audio.success:
    case questionsTypes.upload_image.success:
    case "RESET_PROGRESS": {
      return {
        progress: 0
      }
    }

    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/progressReducer.js